<template>
  <div v-if="user == 0 & owner === 'drr'">
    <b-card style="background-color: rgb(255, 127, 96, 0.0); border: 2px solid #00B058; border-radius: 40px 4px 40px 4px;">
      <div>
        <b-img
          class="mr-1 mb-1"
          height="25"
          src="@/assets/images/icons/iconcardb.svg"
        />
        <span style="font-size:20px; color: #fff; font-weight: 600;">ปริมาณจราจรทุกสายทาง</span>
      </div>
      <div>
        <app-echart-bar
          :option-data="optionBar"
          style="width:auto;"
        />
      </div>
    </b-card>
  </div>
</template>

<script>
import { BCard, BImg } from 'bootstrap-vue'
import * as echarts from 'echarts'
import axios from '@axios'
import AppEchartBar from '@/views/dashboard/garaphDB/AppEchartBarDB.vue'

export default {
  components: {
    BCard,
    BImg,
    AppEchartBar,
  },
  data() {
    return {
      owner: '',
      user: '',
      optionBar: {
        xAxisData: [],
        series: [
          {
            name: 'ทั้งหมด',
            type: 'bar',
            stack: 'Total',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: '#99FBCA',
                },
                {
                  offset: 1,
                  color: '#00B058',
                },
              ]),
              barBorderRadius: [4, 4, 0, 0],
            },
            data: [],
            barMaxWidth: '40%',
            barMinWidth: '10px',
          },
        ],
      },
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
    this.owner = this.userData.groupname
    this.user = this.userData.department
    this.getBarChart()
    this.interval = setInterval(() => {
      this.getBarChart()
    }, 300000)
  },
  methods: {
    getBarChart() {
      axios
        .post('/getBarCountDB', {
          department: this.userData.department,
          owner: this.userData.groupname,
          username: this.userData.username,
        })
        .then(response => {
          this.xAxisData = []
          this.optionBar.xAxisData.splice(0)
          this.optionBar.series[0].data.splice(0)
          this.xAxisData = response.data
          this.xAxisData.forEach(value => {
            this.optionBar.xAxisData.push(value.Date_Name)
            this.optionBar.series[0].data.push(value.Total)
          })
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>
